import {Directive, inject, input, output} from '@angular/core';
import {NgxSmartModalComponent} from 'ngx-smart-modal';
import {DialogService} from '../services/dialog.service';
import {DialogComponent} from '../components/dialog/dialog.component';

@Directive({
  selector: '[msModalClose]',
  standalone: true,
  host: {
    '(click)': 'clickHandler()',
  },
})
export class ModalCloseDirective<T> {
  readonly returnValue = input<T | undefined>(undefined, {alias: 'msModalClose'});
  readonly closeModal = output<T | undefined>();

  private readonly dialog = inject(NgxSmartModalComponent, {optional: true});
  private readonly dialogWrapper = inject(DialogComponent, {optional: true});
  private readonly dialogService = inject(DialogService);

  private get modalId() {
    return this.dialog?.identifier || this.dialogWrapper?.identifier();
  }

  constructor() {
    if ((!this.dialog && !this.dialogWrapper) || !this.modalId) {
      throw new Error(
        'msModalClose directive should be used inside Dialog or DynamicDialog component and modal ID should be defined.'
      );
    }
  }

  clickHandler(): void {
    const returnValue = this.returnValue();

    this.closeModal.emit(returnValue);
    this.close(returnValue);
  }

  private close(returnValue: T | undefined): void {
    this.dialogService.close<T | undefined>(this.modalId, returnValue);
  }
}
